




import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Form, Button, Tabs, Tab, Spinner, Offcanvas, OverlayTrigger,
  Tooltip, Accordion
} from 'react-bootstrap';
import { BsDownload, BsSearch, BsX } from 'react-icons/bs';
import axios from 'axios';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import ReactPaginate from 'react-paginate';

const TaxList = () => {
  const [vatType, setVatType] = useState('vat');
  const [selectedQuarter, setSelectedQuarter] = useState(null);
  const [quarterOptions, setQuarterOptions] = useState([]);
  const [inVatData, setInVatData] = useState([]);
  const [ouVatData, setOuVatData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('input');
  const [customFromDate, setCustomFromDate] = useState(null);
  const [customToDate, setCustomToDate] = useState(null);
  const [corporateTaxData, setCorporateTaxData] = useState(null);
  const navigate = useNavigate();
  const [showTaxDetails, setShowTaxDetails] = useState(false);
  const [taxDetailType, setTaxDetailType] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalRecords, setTotalRecords] = useState(0);
  const [corporateData, setCorporateData] = useState(null);
  const [expenseData, setExpenseData] = useState(null);
  useEffect(() => {
    if (vatType === 'corporate') {
      if (customFromDate && customToDate) {
        fetchCorporateTax(
          moment(customFromDate).format('YYYY-MM-DD'),
          moment(customToDate).format('YYYY-MM-DD')
        );
        fetchCorporate(
          moment(customFromDate).format('YYYY-MM-DD'),
          moment(customToDate).format('YYYY-MM-DD')
        );
        fetchCorporateExpense(
          moment(customFromDate).format('YYYY-MM-DD'),
          moment(customToDate).format('YYYY-MM-DD')
        );
      } else {
        fetchTaxDetails();
      }
    } else {
      setCustomFromDate(null);
      setCustomToDate(null);
      fetchTaxDetails();
    }
  }, [vatType]);

  const fetchCorporateTax = async (fromDate, toDate) => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');
      const API = process.env.REACT_APP_WEBZASH_URL;
      const APIKEY = process.env.REACT_APP_API_KEY;

      const response = await axios.get(`${API}/api/reports/corporate_tax`, {
        headers: {
          'x-api-key': APIKEY,
        },
        params: {
          startdate: fromDate,
          enddate: toDate
        }
      });

      setCorporateTaxData(response.data?.data);
    } catch (error) {
      console.error("Error fetching corporate tax data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [vatSummary, setVatSummary] = useState({});

  const fetchvatData = async (type, page = 1, perPage = 15, fromDate = null, toDate = null) => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');

      const response = await axios.get(`${backendUrl}/api/reports/vat`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        params: {
          page,
          per_page: perPage,
          from_date: fromDate,
          to_date: toDate,
          type
        },
        skipLoader: true,
      });

      if (type === 'input') {
        setInVatData(response.data.input_vat || []);
        setVatSummary({
          total_input_vat: response.data.total_input_vat,
          total_output_vat: response.data.total_output_vat,
          vat_payable: response.data.vat_payable,
          start_date: fromDate,  // ✅ use param
          end_date: toDate,
        });

      } else {
        setOuVatData(response.data.output_vat || []);
      }
      setTotalRecords(response.data.input_total || response.data.output_total || 0);
    } catch (error) {
      console.error('Error fetching VAT data:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadVATReport = async () => {
    try {
      const type = activeTab === 'input' ? 'input' : 'output';
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');
      setLoading(true);

      const response = await axios.get(`${backendUrl}/api/reports/vat-summary`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        params: {
          type,
          from_date: selectedQuarter?.from,
          to_date: selectedQuarter?.to
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `vat_report_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading report:", error);
      alert('Failed to download report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const downloadCorporateTaxReport = async () => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');

      const response = await axios.get(`${backendUrl}/api/reports/corporate-tax-export`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        params: {
          from_date: customFromDate,
          to_date: customToDate
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `corporate_tax_report_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading corporate tax report:", error);
      alert('Failed to download report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const monthNameToNumber = (monthName) => {
    const months = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };
    return months[monthName];
  };

  const fetchTaxDetails = async (customFromDate = null, customToDate = null) => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');

      const response = await axios.get(`${backendUrl}/api/settings/tax`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
      });

      const settings = response.data.setting;
      const financialYear = new Date().getFullYear();
      const startMonth = monthNameToNumber(settings.start_month);
      const endMonth = monthNameToNumber(settings.end_month);

      const fromDate = customFromDate
        ? new Date(customFromDate)
        : new Date(`${financialYear}-${startMonth}-01`);
      const toDate = customToDate
        ? new Date(customToDate)
        : new Date(`${financialYear}-${endMonth}-01`);

      toDate.setMonth(toDate.getMonth() + 1);
      toDate.setDate(0);

      const quarters = [
        {
          key: 'q1',
          label: `Q1 (${settings.q1_start_month} - ${settings.q1_end_month})`,
          from: `${financialYear}-01-01`,
          to: `${financialYear}-03-31`
        },
        {
          key: 'q2',
          label: `Q2 (${settings.q2_start_month} - ${settings.q2_end_month})`,
          from: `${financialYear}-04-01`,
          to: `${financialYear}-06-30`
        },
        {
          key: 'q3',
          label: `Q3 (${settings.q3_start_month} - ${settings.q3_end_month})`,
          from: `${financialYear}-07-01`,
          to: `${financialYear}-09-30`
        },
        {
          key: 'q4',
          label: `Q4 (${settings.q4_start_month} - ${settings.q4_end_month})`,
          from: `${financialYear}-10-01`,
          to: `${financialYear}-12-31`
        }
      ];

      setQuarterOptions(quarters);

      const today = new Date();
      const currentQuarter = quarters.find(q => {
        const fromDate = new Date(q.from);
        const toDate = new Date(q.to);
        return today >= fromDate && today <= toDate;
      });

      if (currentQuarter) {
        setSelectedQuarter(currentQuarter);
        if (vatType === 'corporate' && !customFromDate && !customToDate) {
          fetchCorporateTax(fromDate.toISOString().split('T')[0], toDate.toISOString().split('T')[0]);
          fetchCorporate(fromDate.toISOString().split('T')[0], toDate.toISOString().split('T')[0]);
          fetchCorporateExpense(fromDate.toISOString().split('T')[0], toDate.toISOString().split('T')[0]);
        }
        if (vatType === 'vat' && currentQuarter) {
          fetchCorporateTax(currentQuarter.from, currentQuarter.to);
          fetchvatData('input', 1, 15, currentQuarter.from, currentQuarter.to);
          fetchvatData('output', 1, 15, currentQuarter.from, currentQuarter.to);
        }
      }
    } catch (error) {
      console.error('Error fetching tax settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerate = () => {
    if (vatType === 'corporate') {
      if (!customFromDate || !customToDate) {
        alert('Please select both From and To dates');
        return;
      }

      const isValidFrom = moment(customFromDate).isValid();
      const isValidTo = moment(customToDate).isValid();

      if (!isValidFrom || !isValidTo) {
        alert('Invalid date format. Please check your date inputs.');
        return;
      }

      const formattedFrom = moment(customFromDate).format('YYYY-MM-DD');
      const formattedTo = moment(customToDate).format('YYYY-MM-DD');

      fetchCorporateTax(formattedFrom, formattedTo);
      fetchCorporate(formattedFrom, formattedTo);
      fetchCorporateExpense(formattedFrom, formattedTo);
    } else {
      if (!selectedQuarter) return;

      Promise.all([
        fetchCorporateTax(selectedQuarter.from, selectedQuarter.to),
        fetchCorporate(selectedQuarter.from, selectedQuarter.to),
        fetchCorporateExpense(selectedQuarter.from, selectedQuarter.to),
        fetchvatData('input', 1, 15, selectedQuarter.from, selectedQuarter.to),
        fetchvatData('output', 1, 15, selectedQuarter.from, selectedQuarter.to)
      ]);
    }
  };

  const handleClear = () => {
    if (vatType === 'corporate') {
      setCustomFromDate(null);
      setCustomToDate(null);
      setCorporateTaxData(null);
    } else {
      setSelectedQuarter(null);
      setCorporateTaxData(null);
      setInVatData([]);
      setOuVatData([]);
    }
  };
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const handleInvoiceClick = (invoice, type) => {
    if (type === 'input') {
      if (invoice.tax_id) {
        navigate(`/tax-invoice/details/${invoice.tax_id}`);
      }
    } else if (type === 'output') {
      setSelectedInvoice(invoice);
      setShowInvoiceDetails(true);
    }
  };

  const InvoiceDetailsModal = () => {
    if (!selectedInvoice) return null;

    const invoiceData = selectedInvoice.projectexp || {};
    const vendorData = selectedInvoice.transaction?.vendor || selectedInvoice.projectexp?.vendor || {};
    const userData = selectedInvoice.transaction?.user || {};
    const accountData = selectedInvoice.transaction?.account || {};
    const isForeignCurrency = vendorData.currency !== '';
    console.log('Vendor Data:', isForeignCurrency);
    const exchangeRate = Number(selectedInvoice['Exchange Rate']) || 1;

    // Backend VAT in :
    const vat = Number(selectedInvoice['5% VAT'] || 0);

    // Compute original VAT in USD (from taxable amount):
    const taxableUSD = Number(invoiceData.amount_without_tax || 0);
    // const taxRate = Number(invoiceData.tax || 0); // usually 5
    const vatUSD = isForeignCurrency ? (taxableUSD * 5) / 100 : vat;
    const taxRate = Number(invoiceData.tax || 0) / 100;
    const vatBase = Number(invoiceData.amount_without_tax || 0);

    // VAT in original currency (USD if foreign vendor)
    const vatOriginal = taxableUSD * taxRate;

    // VAT in AED (convert using exchange rate if foreign)
    const vatConverted = isForeignCurrency ? vatOriginal * exchangeRate : vatOriginal;

    // Compute total converted amount (already in  from backend):
    const convertedAmount = Number(invoiceData.total_amount || 0) * exchangeRate;
    const convertedAmountWithoutTax = Number(invoiceData.amount_without_tax || 0) * exchangeRate;
    const convertAdjustmentAmount = Number(invoiceData.adjustment_amount || 0) * exchangeRate;
    console.log('Converted Amount:', convertedAmount);
    console.log('Converted Amount Without Tax:', convertedAmountWithoutTax);
    console.log('Exchange Rate:', exchangeRate);
    console.log('VAT USD:', vatUSD);
    console.log('VAT:', vat);

    return (
      <Offcanvas
        show={showInvoiceDetails}
        onHide={() => setShowInvoiceDetails(false)}
        placement="end"
        className="w-md-50"
        style={{width:'480px'}}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Invoice Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex flex-column h-100">
            {/* Invoice Preview Section */}
            <div className="mb-4 border-bottom pb-3">
              <h5 className="mb-3">Invoice Preview</h5>
              {invoiceData.attatchment ? (
                <div className="border rounded p-2 bg-light" style={{ height: '300px' }}>
                  <iframe
                    src={`${process.env.REACT_APP_BACKEND_URL}/storage/${invoiceData.attatchment}`}
                    title="Invoice Preview"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  />
                </div>
              ) : (
                <div className="text-center py-5 bg-light rounded">
                  <i className="bx bx-file-blank display-4 text-muted"></i>
                  <p className="mt-2 mb-0">No attachment available</p>
                </div>
              )}
            </div>

            {/* Invoice Details Section */}
            <div className="flex-grow-1">
              <h5 className="mb-3">Invoice Details</h5>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Vendor Name</p>
                    <p className="mb-0 fw-medium">{vendorData.name || '-'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Invoice Number</p>
                    <p className="mb-0 fw-medium">{selectedInvoice['Invoice No'] || '-'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Date</p>
                    <p className="mb-0 fw-medium">
                      {moment(selectedInvoice.Date).format('DD MMM YYYY') || '-'}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Bank Account</p>
                    <p className="mb-0 fw-medium">{accountData.name || '-'}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Amount Without Tax</p>
                    <p className="mb-0 fw-medium">
                      {Number(invoiceData.amount_without_tax || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}{' '}
                      {isForeignCurrency && (
                        <>
                          <br />
                          <small className="text-success">
                            ≈ {convertedAmountWithoutTax.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </small>
                        </>
                      )}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Tax ({invoiceData.tax || 0}%)</p>
                    <p className="mb-0 fw-medium">
                      {vatOriginal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

                      {isForeignCurrency && (
                        <>
                          <br />
                          <small className="text-success">
                            ≈{vatConverted.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </small>
                        </>
                      )}
                    </p>

                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Adjustment Amount</p>
                    <p className="mb-0 fw-medium">
                      {Number(invoiceData.adjustment_amount || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}{' '}
                      {isForeignCurrency && (
                        <>
                          <br />
                          <small className="text-success">
                            ≈ {convertAdjustmentAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </small>
                        </>
                      )}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <p className="mb-1 text-muted">Total Amount</p>
                    <p className="mb-0 fw-medium text-primary">
                      {Number(invoiceData.total_amount || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}{' '}
                      {isForeignCurrency && (
                        <>
                          <br />
                          <small className="text-success">
                            ≈ {convertedAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </small>
                        </>
                      )}
                    </p>
                  </div>
                </Col>
              </Row>

              {/* Currency Conversion Section */}
              {isForeignCurrency && (
                <div className="mt-4 pt-3 border-top">
                  <h6 className="mb-3">Currency Conversion Details</h6>
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <p className="mb-1 text-muted">Exchange Rate</p>
                        <p className="mb-0 fw-medium">
                          {Number(exchangeRate).toFixed(4)}
                        </p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <p className="mb-1 text-muted">Conversion Date</p>
                        <p className="mb-0 fw-medium">
                          {moment(selectedInvoice.Date).format('DD MMM YYYY')}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>

            {/* Footer with action buttons */}
            <div className="mt-auto pt-3 border-top">
              <Button variant="light" className="me-2" onClick={() => setShowInvoiceDetails(false)}>
                Close
              </Button>
              {/* {invoiceData.attatchment && (
                <Button
                  variant="light"
                  onClick={() => window.open(
                    `${process.env.REACT_APP_BACKEND_URL}/storage/${invoiceData.attatchment}`,
                    '_blank'
                  )}
                >
                  <i className="bx bx-show me-1"></i> View Invoice
                </Button>
              )} */}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    );
  };

  const VatSummaryCards = ({ summary }) => {
    if (!summary || vatType !== 'vat') return null;

    return (
      <Row className="mb-4">
        <Col md={4}>
          <Card className="card-hover shadow-sm border-primary">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-2">Input VAT</h6>
                  <h3 className="mb-0 text-primary">
                    {Number(summary.total_input_vat || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </h3>
                </div>
                <div className="avatar-sm">
                  <span className="avatar-title bg-primary rounded-circle">
                    <i className="bx bx-receipt font-size-24"></i>
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <span className="badge bg-light bg-opacity-10 text-primary">
                  {moment(summary.start_date).format('DD MMM YYYY')} - {moment(summary.end_date).format('DD MMM YYYY')}
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Same fix for Output VAT */}
        <Col md={4}>
          <Card className="card-hover shadow-sm border-success">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-2">Output VAT</h6>
                  <h3 className="mb-0 text-success">
                    {Number(summary.total_output_vat || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </h3>
                </div>
                <div className="avatar-sm">
                  <span className="avatar-title bg-success rounded-circle">
                    <i className="bx bx-receipt font-size-24"></i>
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <span className="badge bg-success bg-opacity-10 text-success">
                  {moment(summary.start_date).format('DD MMM YYYY')} - {moment(summary.end_date).format('DD MMM YYYY')}
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* VAT Payable */}
        <Col md={4}>
          <Card className={`card-hover shadow-sm ${summary.vat_payable >= 0 ? 'border-danger' : 'border-info'}`}>
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-2">VAT Payable</h6>
                  <h3 className={`mb-0 ${summary.vat_payable >= 0 ? 'text-danger' : 'text-info'}`}>
                    {Number(summary.vat_payable || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                    <small className="font-size-14 ms-1">
                      {summary.vat_payable >= 0 ? '(Payable)' : '(Refundable)'}
                    </small>
                  </h3>
                </div>
                <div className="avatar-sm">
                  <span className={`avatar-title rounded-circle ${summary.vat_payable >= 0 ? 'bg-danger' : 'bg-info'}`}>
                    <i className="bx bx-money font-size-24"></i>
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <span className={`badge ${summary.vat_payable >= 0 ? 'bg-danger bg-opacity-10 text-danger' : 'bg-info bg-opacity-10 text-info'}`}>
                  {moment(summary.start_date).format('DD MMM YYYY')} - {moment(summary.end_date).format('DD MMM YYYY')}
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };
  const handleTaxDetailClick = (type) => {
    setTaxDetailType(type);
    setShowTaxDetails(true);
  };

  const fetchCorporate = async (fromDate, toDate) => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');
      const API = process.env.REACT_APP_WEBZASH_URL;
      const APIKEY = process.env.REACT_APP_API_KEY;

      const response = await axios.get(`${backendUrl}/api/corporate-tax/revenue`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        params: {
          startdate: fromDate,
          enddate: toDate
        }
      });

      setCorporateData(response.data || { total_income: 0 });



    } catch (error) {
      console.error("Error fetching corporate tax data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCorporateExpense = async (fromDate, toDate) => {
    try {
      setLoading(true);
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');
      const API = process.env.REACT_APP_WEBZASH_URL;
      const APIKEY = process.env.REACT_APP_API_KEY;

      const response = await axios.get(`${backendUrl}/api/corporate-tax/expenses`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        params: {
          startdate: fromDate,
          enddate: toDate
        }
      });

      setExpenseData(response.data || { total_income: 0 });



    } catch (error) {
      console.error("Error fetching corporate tax data:", error);
    } finally {
      setLoading(false);
    }
  };


  // const renderCorporateTaxTable = () => {
  //   if (!corporateTaxData) return (
  //     <div className="text-center py-5">
  //       <div className="text-muted">No data available for the selected period</div>
  //     </div>
  //   );

  //   const {

  //     input_vat,
  //     output_vat,
  //     vat_payable
  //   } = corporateTaxData;
  //   const { total_income = 0 } = corporateData || {};
  //   const { total_expense = 0 } = expenseData || {};

  //   const net_profit = Number(total_income) - Number(total_expense);
  //   const corporate_tax = net_profit * 0.09;

  //   return (
  //     <div className="table-responsive">
  //       <table className="table align-middle table-nowrap table-check table-list">
  //         <thead className="table-sales-gradient">
  //           <tr>
  //             <th className="align-middle">#</th>
  //             <th className="align-middle">Income</th>
  //             <th className="align-middle">Expenses</th>
  //             <th className="align-middle">Profit</th>
  //             <th className="align-middle">Corporate Tax (9%)</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           <tr>
  //             <td>1</td>
  //             <td
  //               className="clickable text-primary fw-bold"
  //               onClick={() => handleTaxDetailClick('income')}
  //             >
  //               {Number(total_income).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               })}
  //             </td>
  //             <td
  //               className="clickable text-primary fw-bold"
  //               onClick={() => handleTaxDetailClick('expense')}
  //             >
  //               {Number(total_expense).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               })}
  //             </td>
  //             <td
  //               className="clickable text-primary fw-bold"
  //               onClick={() => handleTaxDetailClick('tax')}
  //             >
  //               {Number(net_profit).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               })}
  //             </td>
  //             <td
  //               className="clickable text-danger fw-bold"
  //               onClick={() => handleTaxDetailClick('tax')}
  //             >
  //               {Number(corporate_tax).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               })}
  //             </td>

  //           </tr>
  //         </tbody>
  //       </table>
  //     </div>
  //   );
  // };
  
  
  const renderCorporateTaxTable = () => {
  // Check what data we have
  const hasCorporateTaxData = corporateTaxData && Object.keys(corporateTaxData).length > 0;
  const hasCorporateData = corporateData && Object.keys(corporateData).length > 0;
  const hasExpenseData = expenseData && Object.keys(expenseData).length > 0;

  // Determine which data source to use based on your business logic
  const useCorporateTaxData = hasCorporateTaxData;
  const useCorporateData = !hasCorporateTaxData && hasCorporateData;
  const useExpenseData = !hasCorporateTaxData && !hasCorporateData && hasExpenseData;

  if (!hasCorporateTaxData && !hasCorporateData && !hasExpenseData) {
    return (
      <div className="text-center py-5">
        <div className="text-muted">No data available for the selected period</div>
      </div>
    );
  }

  // Calculate values based on available data source
  let finalIncome = 0;
  let finalExpense = 0;
  let finalNetProfit = 0;
  let finalCorporateTax = 0;
  let input_vat = 0;
  let output_vat = 0;
  let vat_payable = 0;

  if (useCorporateTaxData) {
    finalIncome = corporateTaxData.total_income || 0;
    finalExpense = corporateTaxData.total_expense || 0;
    finalNetProfit = corporateTaxData.net_profit || 0;
    finalCorporateTax = corporateTaxData.corporate_tax || 0;
    input_vat = corporateTaxData.input_vat || 0;
    output_vat = corporateTaxData.output_vat || 0;
    vat_payable = corporateTaxData.vat_payable || 0;
  } else if (useCorporateData) {
    finalIncome = corporateData.total_income || 0;
    finalExpense = expenseData?.total_expense || 0;
    finalNetProfit = Number(finalIncome) - Number(finalExpense);
    finalCorporateTax = finalNetProfit * 0.09;
  } else if (useExpenseData) {
    finalIncome = 0; // Expense data only has expenses
    finalExpense = expenseData.total_expense || 0;
    finalNetProfit = -finalExpense; // Negative profit if only expenses
    finalCorporateTax = 0; // No corporate tax if no income
  }

  const showVatColumns = useCorporateTaxData && (input_vat || output_vat || vat_payable);

  return (
    <div className="table-responsive">
      <table className="table align-middle table-nowrap table-check table-list">
        <thead className="table-sales-gradient">
          <tr>
            <th className="align-middle">#</th>
            <th className="align-middle">Income</th>
            <th className="align-middle">Expenses</th>
            <th className="align-middle">Profit</th>
            <th className="align-middle">Corporate Tax (9%)</th>
           
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td
              className="clickable text-black fw-bold"
              onClick={() => handleTaxDetailClick('income')}
            >
              {Number(finalIncome).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td
              className="clickable text-black fw-bold"
              onClick={() => handleTaxDetailClick('expense')}
            >
              {Number(finalExpense).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td
              className={`clickable fw-bold ${finalNetProfit >= 0 ? 'text-black' : 'text-black'}`}
              onClick={() => handleTaxDetailClick('tax')}
            >
              {Number(finalNetProfit).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td
              className="clickable text-black fw-bold"
              onClick={() => handleTaxDetailClick('tax')}
            >
              {Number(finalCorporateTax).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
         
          </tr>
        </tbody>
      </table>
      
     
    </div>
  );
};
  const getInvoiceStatusBadge = (status) => {
    const statusMap = {
      'paid': 'bg-success',
      'pending': 'bg-warning',
      'overdue': 'bg-danger',
      'draft': 'bg-secondary'
    };
    return statusMap[status] || 'bg-light text-dark';
  };
  const TaxDetailsOffcanvas = () => {
    if (!corporateTaxData) return null;

    // Group expenses by ledger
    const groupedExpenses = corporateTaxData.expense_breakdown.reduce((acc, expense) => {
      const ledger = expense.Ledger.ledger_name;
      if (!acc[ledger]) {
        acc[ledger] = {
          totalAmount: 0,
          totalDeductible: 0,
          deductionRate: expense.Ledger.deduction_rate,
          items: []
        };
      }
      acc[ledger].totalAmount += Number(expense.Entryitem.amount);
      acc[ledger].totalDeductible += Number(expense[0].deductible_amount);
      acc[ledger].items.push(expense);
      return acc;
    }, {});

    return (
      <Offcanvas
        show={showTaxDetails}
        onHide={() => setShowTaxDetails(false)}
        placement="end"
        className="w-md-50"
        style={{ width: '500px' }}
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title className="fw-bold">
            {taxDetailType === 'income' ? 'Income Breakdown' :
              taxDetailType === 'tax' ? 'Tax Calculation' :
                'Expense Breakdown'}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {/* {taxDetailType === 'income' && (
            <div className="d-flex flex-column h-100">
              <div className="p-3 bg-light border-bottom">
                <Card className="shadow-sm">
                  <Card.Body className="py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="text-muted mb-1">Total Income</h6>
                        <h4 className="mb-0 text-primary">
                          {Number(corporateTaxData.total_income).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </h4>
                      </div>
                      <div className="avatar-sm">
                        <span className="avatar-title bg-primary rounded-circle">
                          <i className="bx bx-money font-size-20"></i>
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div className="flex-grow-1 p-3" style={{ overflowY: 'auto' }}>
                <h5 className="mb-3">Income by Account</h5>

                {(() => {
                  const groupedIncome = corporateTaxData.income_breakdown.reduce((acc, income) => {
                    const ledger = income.Ledger.ledger_name || 'Other Income';
                    if (!acc[ledger]) {
                      acc[ledger] = {
                        totalAmount: 0,
                        items: []
                      };
                    }
                    acc[ledger].totalAmount += Number(income.Entryitem.amount);
                    acc[ledger].items.push(income);
                    return acc;
                  }, {});

                  return Object.entries(groupedIncome).map(([ledger, data], index) => (
                    <Card key={index} className="mb-3 shadow-sm border-0">
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0 fw-bold">{ledger}</h6>
                          <span className="badge bg-light text-dark">
                            {data.items.length} {data.items.length > 1 ? 'transactions' : 'transaction'}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between align-items-end">
                          <div className="text-end">
                            <small className="text-muted">Total Amount</small>
                            <p className="mb-0 fw-bold text-primary">
                              {data.totalAmount.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </p>
                          </div>
                        </div>

                        <Accordion className="mt-3">
                          <Accordion.Item eventKey={index.toString()}>
                            <Accordion.Header className="py-1">
                              <small>View Transactions</small>
                            </Accordion.Header>
                            <Accordion.Body className="p-0">
                              <div className="table-responsive">
                                <table className="table table-sm table-borderless mb-0">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Description</th>
                                      <th className="text-end">Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.items.map((item, idx) => (
                                      <tr key={idx} className="border-top">
                                        <td>{moment(item.Entry.date).format('DD MMM YYYY')}</td>
                                        <td className="text-truncate" style={{ maxWidth: '150px' }} title={item.Entry.narration}>
                                          {item.Entry.narration || '-'}
                                        </td>
                                        <td className="text-end">
                                          {Number(item.Entryitem.amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Card.Body>
                    </Card>
                  ));
                })()}
              </div>
            </div>
          )} */}
          {/* {taxDetailType === 'income' && corporateData?.projects?.length > 0 && (
            <div className="d-flex flex-wrap gap-3 p-3">
              {corporateData.projects.map((project, index) => (
                <Card
                  key={index}
                  className="shadow-sm flex-grow-1"
                  style={{ minWidth: '220px', maxWidth: '250px' }}
                >
                  <Card.Body>
                    <h6 className="fw-bold mb-2">{project.project_name}</h6>

                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Total Revenue</small>
                      <span className="fw-bold text-primary">
                        {Number(project.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between">
                      <small className="text-muted">Recognized</small>
                      <span className="fw-bold text-success">
                        {Number(project.recognized_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mt-1">
                      <small className="text-muted">Recognized %</small>
                      <span className="fw-bold text-info">
                        {((project.recognized_amount / project.total_amount) * 100).toFixed(2)}%
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          )} */}
          {taxDetailType === 'expense' && expenseData?.vendors?.length > 0 && (
            <div className="d-flex flex-column h-100">
              {/* Summary Header */}
              <div className="p-3 bg-light border-bottom">
                <Card className="shadow-sm">
                  <Card.Body className="py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="text-muted mb-1">Total Expense</h6>
                        <h4 className="mb-0 text-primary">
                          {expenseData.vendors.reduce((sum, vendor) =>
                            sum + Number(vendor.total_recognized), 0).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                        </h4>
                      </div>
                      <div className="avatar-sm">
                        <span className="avatar-title bg-primary rounded-circle">
                          <i className="bx bx-money font-size-20"></i>
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              {/* Project Groups */}
              <div className="flex-grow-1 p-3" style={{ overflowY: 'auto' }}>
                <h5 className="mb-3">Expenses</h5>

                {expenseData.vendors?.map((project, index) => (
                  <Card key={index} className="mb-3 shadow-lg border-0">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 fw-bold">{project.expense_type_name}</h6>
                        <span className="badge bg-light text-dark">
                          {project.expense_type_name || 'Standard Project'}
                        </span>
                      </div>

                      {/* Revenue Metrics */}
                      <Row className="g-3">
                        <Col md={6}>
                          <div className="border rounded p-2 bg-light">
                            <small className="text-muted d-block">Total Value</small>
                            <span className="fw-bold text-dark">
                              {/* {Number(project?.records?.project?.total_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })} */}
                              {Number(project.records[0]?.original_amount || 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}

                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="border rounded p-2 bg-success bg-opacity-10">
                            <small className="text-muted d-block">Recognized Expense</small>
                            <span className="fw-bold text-success">
                              {Number(project.total_recognized).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        </Col>
                      </Row>


                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {taxDetailType === 'income' && corporateData?.projects?.length > 0 && (
            <div className="d-flex flex-column h-100">
              {/* Summary Header */}
              <div className="p-3 bg-light border-bottom">
                <Card className="shadow-sm">
                  <Card.Body className="py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="text-muted mb-1">Total Income</h6>
                        <h4 className="mb-0 text-primary">
                          {corporateData.projects.reduce((sum, project) =>
                            sum + Number(project.recognized_amount), 0).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                        </h4>
                      </div>
                      <div className="avatar-sm">
                        <span className="avatar-title bg-primary rounded-circle">
                          <i className="bx bx-money font-size-20"></i>
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              {/* Project Groups */}
              <div className="flex-grow-1 p-3" style={{ overflowY: 'auto' }}>
                <h5 className="mb-3">Revenue by Projects</h5>

                {corporateData.projects?.map((project, index) => (
                  <Card key={index} className="mb-3 shadow-lg border-0">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 fw-bold">{project.project_name}</h6>
                        <span className="badge bg-light text-dark">
                          {project.project_type || 'Standard Project'}
                        </span>
                      </div>

                      {/* Revenue Metrics */}
                      <Row className="g-3">
                        <Col md={6}>
                          <div className="border rounded p-2 bg-light">
                            <small className="text-muted d-block">Total Contract Value</small>
                            <span className="fw-bold text-dark">
                              {/* {Number(project?.records?.project?.total_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })} */}
                              {Number(project.records[0]?.project?.total_amount || 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}

                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="border rounded p-2 bg-success bg-opacity-10">
                            <small className="text-muted d-block">Recognized Revenue</small>
                            <span className="fw-bold text-success">
                              {Number(project.recognized_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        </Col>
                      </Row>

                      {/* Progress Indicator */}
                      {/* <div className="mt-3">
                        <div className="d-flex justify-content-between mb-1">
                          <small className="text-muted">Recognition Progress</small>
                          <small className="fw-bold text-info">
                            {((project.recognized_amount / project.total_amount) * 100).toFixed(2)}%
                          </small>
                        </div>
                        <div className="progress" style={{ height: '6px' }}>
                          <div
                            className="progress-bar bg-info"
                            role="progressbar"
                            style={{ width: `${(project.recognized_amount / project.total_amount) * 100}%` }}
                            aria-valuenow={(project.recognized_amount / project.total_amount) * 100}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div> */}

                      {/* Invoice Details Accordion */}
                      {/* <Accordion className="mt-3">
                        <Accordion.Item eventKey={index.toString()}>
                          <Accordion.Header className="py-1">
                            <small>View Invoice Details</small>
                          </Accordion.Header>
                          <Accordion.Body className="p-0">
                            <div className="table-responsive">
                              <table className="table table-sm table-borderless mb-0">
                                <thead>
                                  <tr>
                                    <th>Invoice </th>
                                    <th className="text-end">Amount</th>
                                    <th className="text-end">Recognized</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {project.records.length > 0 ? (
                                    project.records.map((record, idx) => {
                                      const invoice = record.proforma_invoice;
                                      return (
                                        <tr key={idx} className="border-top">
                                          <td className="fw-bold">{invoice?.serial_no || '-'}</td>
                                          <td className="text-end">
                                            {Number(invoice?.quot_total_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </td>
                                          <td className="text-end text-success">
                                            {Number(record.recognized_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </td>
                                          <td>
                                            <span className={`badge ${getInvoiceStatusBadge(invoice?.pi_status)}`}>
                                              {invoice?.pi_status || '-'}
                                            </span>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan="5" className="text-center text-muted py-3">
                                        No invoice details available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>

                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion> */}
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>
          )}
          {taxDetailType === 'tax' && (
            <div className="p-3">
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">Tax Calculation</h5>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total Income:</span>
                    <span>
                      {Number(corporateTaxData.total_income).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total Expenses:</span>
                    <span>
                      {Number(corporateTaxData.total_expense).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2 border-top pt-2">
                    <span className="fw-bold">Net Profit:</span>
                    <span className="fw-bold">
                      {Number(corporateTaxData.net_profit).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Tax Rate:</span>
                    <span>9%</span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold border-top pt-2">
                    <span>Corporate Tax:</span>
                    <span className="text-danger">
                      {Number(corporateTaxData.corporate_tax).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                </div>
              </div>

              {/* <div className="card">
                <div className="card-body">
                  <h5 className="card-title">VAT Summary</h5>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Input VAT:</span>
                    <span>
                      {Number(corporateTaxData.input_vat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Output VAT:</span>
                    <span>
                      {Number(corporateTaxData.output_vat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold border-top pt-2">
                    <span>VAT Payable:</span>
                    <span className={corporateTaxData.vat_payable >= 0 ? 'text-danger' : 'text-success'}>
                      {Number(corporateTaxData.vat_payable).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                      {corporateTaxData.vat_payable >= 0 ? ' (Payable)' : ' (Refundable)'}
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
          )}

          {/* {taxDetailType === 'expense' && (
            <div className="d-flex flex-column h-100">
              <div className="p-3 bg-light border-bottom">
                <Row>
                  <Col md={6}>
                    <Card className="mb-3 mb-md-0 shadow-sm">
                      <Card.Body className="py-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="text-muted mb-1">Total Expenses</h6>
                            <h4 className="mb-0 text-primary">
                              {Number(corporateTaxData.total_expense_gross).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </h4>
                          </div>
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary rounded-circle">
                              <i className="bx bx-money font-size-20"></i>
                            </span>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="shadow-sm">
                      <Card.Body className="py-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="text-muted mb-1">Deductible Amount</h6>
                            <h4 className="mb-0 text-success">
                              {Number(corporateTaxData.total_expense_deductible).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </h4>
                          </div>
                          <div className="avatar-sm">
                            <span className="avatar-title bg-success rounded-circle">
                              <i className="bx bx-check-circle font-size-20"></i>
                            </span>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>

              <div className="flex-grow-1 p-3" style={{ overflowY: 'auto' }}>
                <h5 className="mb-3">Expense Categories</h5>
                {Object.entries(groupedExpenses).map(([ledger, data], index) => (
                  <Card key={index} className="mb-3 shadow-sm border-0">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 fw-bold">{ledger}</h6>
                        <span className="badge bg-light text-dark">
                          {data.items.length} {data.items.length > 1 ? 'transactions' : 'transaction'}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <small className="text-muted">Deduction Rate</small>
                          <p className="mb-0">{data.deductionRate}%</p>
                        </div>
                        <div className="text-end">
                          <small className="text-muted">Total Amount</small>
                          <p className="mb-0">
                            {data.totalAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </p>
                        </div>
                        <div className="text-end">
                          <small className="text-muted">Deductible</small>
                          <p className="mb-0 fw-bold text-success">
                            {data.totalDeductible.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </p>
                        </div>
                      </div>

                      <Accordion className="mt-3">
                        <Accordion.Item eventKey={index.toString()}>
                          <Accordion.Header className="py-1">
                            <small>View Transactions</small>
                          </Accordion.Header>
                          <Accordion.Body className="p-0">
                            <div className="table-responsive">
                              <table className="table table-sm table-borderless mb-0">
                                <thead>
                                  <tr>
                                    <th>Date</th>
                                    <th>Narration</th>
                                    <th className="text-end">Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {data.items.map((item, idx) => (
                                    <tr key={idx} className="border-top">
                                      <td>{moment(item.Entry.date).format('DD MMM')}</td>
                                      <td className="text-truncate" style={{ maxWidth: '150px' }} title={item.Entry.narration}>
                                        {item.Entry.narration || '-'}
                                      </td>
                                      <td className="text-end">
                                        {Number(item.Entryitem.amount).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>
          )} */}
        </Offcanvas.Body>
      </Offcanvas>
    );
  };
  const inputVatHeaders = ['Invoice No', 'Date', 'Client', 'Amount', '5% VAT', 'Total Amount'];
  const outputVatHeaders = ['Invoice No', 'Date', 'Vendor\/Client', 'Taxable Amount', '5% VAT', 'Non-Taxable Amount', 'Total Amount'];



  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipContent, setTooltipContent] = useState('');
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  // Add this function to handle showing tooltips
  const showAmountTooltip = (content, position) => {
    setTooltipContent(content);
    setTooltipPosition(position);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 3000);
  };


  const renderTable = (
    data,
    columnKeys = [],
    type = 'input',
    handleInvoiceClick,
    showAmountTooltip
  ) => {
    const headers =
      columnKeys.length > 0
        ? columnKeys
        : data.length > 0
          ? Object.keys(data[0])
          : [];

    const handleAmountClick = (item, amountType, event) => {
      const parseAmount = (val) =>
        Number(String(val || '0').replace(/,/g, '')) || 0;

      // ✅ Vendor logic (keep same as existing)
      if (type === 'output') {
        const vendorCurrency = item.transaction?.vendor?.currency || item.projectexp?.vendor?.currency || '';
        const exchangeRate = parseAmount(item['Exchange Rate']) || 1;
        const taxRate = parseAmount(item.projectexp?.tax);

        if (vendorCurrency === '') {
          const value = parseAmount(item[amountType]);
          const content = `<div>
            <p><strong>${amountType}:</strong> ${value.toFixed(2)} </p>
          </div>`;
          showAmountTooltip(content, { x: event.clientX, y: event.clientY });
          return;
        }

        if (amountType === '5% VAT') {
          const taxableOriginal = parseAmount(item.projectexp?.amount_without_tax);
          const originalVAT = taxableOriginal * (taxRate / 100);
          const convertedVAT = parseAmount(item['5% VAT']);

          const content = `<div>
            <p><strong>Original VAT:</strong> ${originalVAT.toFixed(
            2
          )} ${vendorCurrency}</p>
            <p><strong>Exchange Rate:</strong> = ${exchangeRate.toFixed(
            4
          )} </p>
            <p><strong>Converted VAT:</strong> ${convertedVAT.toFixed(
            2
          )} </p>
          </div>`;
          showAmountTooltip(content, { x: event.clientX, y: event.clientY });
          return;
        }

        let originalAmount = 0;
        let label = amountType;

        if (amountType === 'Taxable Amount') {
          originalAmount = parseAmount(item.projectexp?.amount_without_tax);
        } else if (amountType === 'Total Amount') {
          originalAmount = parseAmount(item.projectexp?.total_amount);
        } else if (amountType === 'Non-Taxable Amount') {
          originalAmount = parseAmount(item.projectexp?.adjustment_amount || 0);
        } else {
          originalAmount = parseAmount(item[amountType]);
        }

        const convertedAmount = originalAmount * exchangeRate;

        const content = `<div>
          <p><strong>${label} (Original):</strong> ${originalAmount.toFixed(
          2
        )} ${vendorCurrency}</p>
          <p><strong>Exchange Rate:</strong> = ${exchangeRate.toFixed(
          4
        )} </p>
          <p><strong>${label} (Converted):</strong> ${convertedAmount.toFixed(
          2
        )} </p>
        </div>`;
        showAmountTooltip(content, { x: event.clientX, y: event.clientY });
        return;
      }

      // ✅ Client logic (new)
      if (type === "input") {
        const clientCurrency = item["Client Currency"] || "";
        // if (clientCurrency === "") return;
        if (clientCurrency === '') {
          const value = parseAmount(item[amountType]);
          const content = `<div>
            <p><strong>${amountType}():</strong> ${value.toFixed(2)}</p>
          </div>`;
          showAmountTooltip(content, { x: event.clientX, y: event.clientY });
          return;
        }

        const exchangeRate = parseAmount(item["Exchange Rate"]) || 1;

        // ✅ Original amount should come from invoice/quotation
        const originalAmount =
          parseAmount(item.invoice?.amount) || 0;

        // ✅  amount is already in "Amount"
        const aedAmount = parseAmount(item["Amount"]);

        const bankName = item.bank || item.account?.name || "-";

        const content = `<div>
      <p><strong>${amountType}(USD):</strong> ${originalAmount.toFixed(
          2
        )} </p>
      <p><strong>Exchange Rate:</strong> ${exchangeRate.toFixed(
          4
        )} </p>
      <p><strong>${amountType} ():</strong> ${aedAmount.toFixed(
          2
        )} </p>
    </div>`;

        showAmountTooltip(content, { x: event.clientX, y: event.clientY });
      }
    };

    return (
      <div className="table-responsive">
        <table className="table align-middle table-nowrap table-check table-list">
          <thead className="table-sales-gradient">
            <tr>
              <th style={{ width: '20px' }} className="align-middle">
                <div className="form-check font-size-16">
                  <input className="form-check-input" type="checkbox" id="checkAll" />
                  <label className="form-check-label" htmlFor="checkAll"></label>
                </div>
              </th>
              <th className="align-middle">#</th>
              {headers.map((key, idx) => (
                <th key={idx}>
                  {key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`rowCheck${idx}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`rowCheck${idx}`}
                      ></label>
                    </div>
                  </td>
                  <td>{idx + 1}</td>
                  {headers.map((key, i) => {
                    const isAmountColumn = [
                      'Amount',
                      'Taxable Amount',
                      'Total Amount',
                      '5% VAT',
                      'Non-Taxable Amount'
                    ].includes(key);
                    const isInvoiceColumn = key === 'Invoice No';

                    return (
                      <td
                        key={i}
                        className={typeof item[key] === 'number' ? 'text-end' : ''}
                        style={
                          isInvoiceColumn && type === 'output'
                            ? { cursor: 'pointer', textDecoration: 'none' }
                            : {}
                        }
                        onClick={(e) => {
                          if (isInvoiceColumn) {
                            handleInvoiceClick(item, type);
                          } else if (isAmountColumn) {
                            handleAmountClick(item, key, e);
                          }
                        }}
                      >
                        {typeof item[key] === 'number'
                          ? item[key].toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })
                          : item[key] ?? '-'}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={headers.length + 1}
                  className="text-center text-muted py-3"
                >
                  No data available for this quarter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {showTooltip && (
          <div
            className="tooltip fade show"
            style={{
              position: 'fixed',
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y - 10}px`,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999,
              backgroundColor: '#fff',
              padding: '8px 12px',
              borderRadius: '4px',
              boxShadow: '0px 2px 8px rgba(0,0,0,0.2)',
              border: '1px solid #ddd'
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: tooltipContent }} />
            <div
              className="tooltip-arrow"
              style={{
                position: 'absolute',
                bottom: '-5px',
                left: '50%',
                width: '10px',
                height: '10px',
                backgroundColor: '#fff',
                transform: 'translateX(-50%) rotate(45deg)',
                borderRight: '1px solid #ddd',
                borderBottom: '1px solid #ddd'
              }}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Tax Reports</h4>
              </div>
            </div>
          </div>

          <Card className="mb-4">
            <Card.Body>
              <Row className="g-3 align-items-end">
                <Col md={3}>
                  <Form.Label className="form-label">Report Type</Form.Label>
                  <Form.Select
                    className="form-select"
                    value={vatType}
                    onChange={(e) => setVatType(e.target.value)}
                  >
                    <option value="vat">VAT Report</option>
                    <option value="corporate">Corporate Tax</option>
                  </Form.Select>
                </Col>

                {vatType === 'vat' ? (
                  <Col md={3}>
                    <Form.Label className="form-label">Financial Quarter</Form.Label>
                    <Form.Select
                      className="form-select"
                      value={selectedQuarter?.key || ''}
                      onChange={(e) => setSelectedQuarter(quarterOptions.find(q => q.key === e.target.value))}
                    >
                      <option value="">Select Quarter</option>
                      {quarterOptions.map(q => (
                        <option key={q.key} value={q.key}>{q.label}</option>
                      ))}
                    </Form.Select>
                  </Col>
                ) : (
                  <>
                    <Col md={2}>
                      <Form.Label className="form-label">From Date</Form.Label>
                      <Form.Control
                        type="date"
                        className="form-control"
                        value={customFromDate || ''}
                        onChange={(e) => setCustomFromDate(e.target.value)}
                      />
                    </Col>
                    <Col md={2}>
                      <Form.Label className="form-label">To Date</Form.Label>
                      <Form.Control
                        type="date"
                        className="form-control"
                        value={customToDate || ''}
                        onChange={(e) => setCustomToDate(e.target.value)}
                      />
                    </Col>
                  </>
                )}

                <Col md={4} className="d-flex justify-content-end gap-2">
                  <Button
                    variant="outline-secondary"
                    onClick={handleClear}
                    disabled={loading}
                  >
                    <BsX className="me-1" /> Clear
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleGenerate}
                    disabled={(vatType === 'vat' ? !selectedQuarter : (!customFromDate || !customToDate))}
                  >


                    <BsSearch className="me-1" />

                    Generate
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {vatType === 'vat' && (
            <>
              <VatSummaryCards summary={vatSummary} />

              {(inVatData.length || ouVatData.length) ? (
                <Card>
                  <Card.Header className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">VAT Detailed Report</h5>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={downloadVATReport}
                      disabled={!selectedQuarter || loading}
                    >
                      <BsDownload className="me-1" />
                      Export Report
                    </Button>
                  </Card.Header>
                  <Card.Body>
                    <Tabs
                      activeKey={activeTab}
                      onSelect={(key) => setActiveTab(key)}
                      className="mb-3"
                      id="vat-tabs"
                    >
                      <Tab eventKey="input" title="Output VAT">
                        {renderTable(inVatData, inputVatHeaders, 'input', handleInvoiceClick, showAmountTooltip)}
                      </Tab>
                      <Tab eventKey="output" title="Input VAT">
                        {renderTable(ouVatData, outputVatHeaders, 'output', handleInvoiceClick, showAmountTooltip)}
                      </Tab>
                    </Tabs>
                    <div className="d-flex justify-content-end pagination-sm">
                      <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        pageCount={Math.ceil(totalRecords / perPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={(selected) => {
                          const page = selected.selected + 1;
                          setCurrentPage(page);
                          fetchvatData(activeTab, page, perPage, selectedQuarter?.from, selectedQuarter?.to);
                        }}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                      />
                    </div>
                  </Card.Body>

                </Card>
              ) : (
                <Card>
                  <Card.Body>
                    <div className="text-center py-5">
                      <div className="text-muted">No VAT data available for the selected quarter</div>
                    </div>
                  </Card.Body>
                  <div className="d-flex justify-content-end pagination-sm">
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      pageCount={Math.ceil(totalRecords / perPage)}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={(selected) => {
                        const page = selected.selected + 1;
                        setCurrentPage(page);
                        fetchvatData(activeTab, page, perPage, selectedQuarter?.from, selectedQuarter?.to);
                      }}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                    />
                  </div>
                </Card>
              )}


            </>
          )}

          {vatType === 'corporate' && (
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Corporate Tax Report</h5>
                {/* {corporateTaxData && (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={downloadCorporateTaxReport}
                    disabled={loading}
                  >
                    <BsDownload className="me-1" />
                    Export Report
                  </Button>
                )} */}
              </Card.Header>
              <Card.Body>
                {renderCorporateTaxTable()}
                <TaxDetailsOffcanvas />
              </Card.Body>
            </Card>
          )}
        </div>
      </div>

      <InvoiceDetailsModal />
    </div>
  );
};

export default TaxList;
